import React, { createContext, useContext, useEffect, useState } from "react";
import { useT } from "@/i18n/translations";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mat_lang") || "de");
  const [theme, setTheme] = useState(() => localStorage.getItem("mat_theme") || "dark");
  const [view, setView] = useState("compare");
  const [quoteDraft, setQuoteDraft] = useState(null);

  useEffect(() => {
    localStorage.setItem("mat_lang", lang);
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("mat_theme", theme);
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
  }, [theme]);

  const { t, tc } = useT(lang);
  const toggleTheme = () => setTheme((p) => (p === "dark" ? "light" : "dark"));

  return (
    <AppCtx.Provider value={{ lang, setLang, theme, toggleTheme, t, tc, view, setView, quoteDraft, setQuoteDraft }}>
      {children}
    </AppCtx.Provider>
  );
}

export function useApp() {
  return useContext(AppCtx);
}
